import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { VenueMarquee } from "@/components/VenueMarquee";
import { Testimonials } from "@/components/Testimonials";
import { InstagramFeed } from "@/components/InstagramFeed";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  useLenis();
  return (
    <LanguageProvider>
      <div className="App relative bg-[#FAF9F6] text-[#1A1A1A] antialiased overflow-x-hidden">
        <Navbar />
        <main>
          <Hero />
          <About />
          <Services />
          <Gallery />
          <VenueMarquee />
          <Testimonials />
          <InstagramFeed />
          <FAQ />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="light" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
